/* eslint-disable no-unused-vars */
const MAIN_APPLICATION_CONTEXT_PATH = '/s2'

// const BASE_URL =
//     process.env.REACT_APP_BASE_URL +
//     process.env.REACT_APP_MAIN_APPLICATION_CONTEXT_PATH
// const BASE_URL = 'https://apiv2.evolvfit.in'
const BASE_URL = 'https://apiv2.evolvfit.in'

// const BASE_URL = process.env.REACT_APP_BASE_URL
// const BASE_URL = 'http://localhost:5000'
// const BASE_URL = 'http://192.168.29.22:5000'
// const BASE_URL = 'http://3.111.4.108:8080'
// const BASE_URL = 'http://10.193.212.12:5000'
// const BASE_URL = 'http://10.193.212.12:5000'
const LOCALHOST_BASE_URL = 'http://192.168.1.80:5000'

const NGROK_URL =
    'https://19d9ec50a9a1.ngrok.io' + MAIN_APPLICATION_CONTEXT_PATH

export default BASE_URL
